<template>
    <div>
        <div class="d-flex flex-wrap h-card-list">
            <div class="h-card flex-shrink" v-if="showAddBtn">
                <div class="h-card-body  d-flex justify-content-center align-items-center flex-column w-100"
                    style="height: 100%; min-width: 160px;">
                    <div class="mb-3">
                        <router-link to="/h5maker/create">
                            <div><i class="bi bi-plus-lg" style="font-size: 52px;"></i></div>
                            <div class="mt-3">空白创建</div>
                        </router-link>
                    </div>
                    <!-- <div>
                    模板创建
                </div> -->
                </div>
            </div>
            <div v-for="(page, index) in list" :key="index" class="h-card">
                <div class="h-card-body d-flex justify-content-center align-items-center flex-column w-100">
                    <div class="flex-grow-0 w-100">
                        <div class="ratio ratio-1x1 d-block overflow-hidden">
                            <div class="bg-light">
                                <img class="img-fluid" :src="addImageSuffix(page.poster, 'small-3x')" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="flex-grow-1 w-100">
                        <div class="fw-bold w-100 p-3">
                            <router-link :to="`/h5maker/edit/${page.id}`">
                                <span v-if="page.name">{{ page.name }}</span>
                                <span v-else class="text-muted">未命名</span>
                            </router-link>
                        </div>
                        <div class="text-start fs-12 text-muted px-3">
                            <span class="me-2">{{ friendlyTime(page.created_at) }}</span>
                            <span v-if="!page.is_published" class="badge text-secondary bg-light">未发布</span>
                        </div>
                        <hr>
                        <div>
                            <div class="btn-group d-flex flex-fill" v-if="page.status == 0">
                                <el-tooltip class="button-item" effect="dark" content="编辑" placement="top">
                                    <router-link :to="`/h5maker/edit/${page.id}`" class="btn">
                                        <i class="bi bi-pencil-square"></i>
                                    </router-link>
                                </el-tooltip>
                                <el-tooltip class="button-item" effect="dark" content="数据" placement="top">
                                    <router-link :to="`/h5maker/statistics/${page.id}`" class="btn"><i
                                            class="bi bi-bar-chart"></i></router-link>
                                </el-tooltip>
                                <el-tooltip class="button-item" effect="dark" content="分享" placement="top">
                                    <router-link :to="`/h5maker/share/${page.id}`" class="btn"><i
                                            class="bi bi-share"></i></router-link>
                                </el-tooltip>
                                <el-dropdown trigger="hover">
                                    <div class="el-dropdown-link ">
                                        <div class="btn">
                                            <i class="bi bi-three-dots"></i>
                                        </div>
                                    </div>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item icon="bi bi-send" v-if="!page.is_published">
                                            <button class="btn btn-sm" @click="togglePublish(page)">发布</button>
                                        </el-dropdown-item>
                                        <el-dropdown-item icon="bi bi-arrow-down-square" v-else>
                                            <button class="btn btn-sm" @click="togglePublish(page)">下架</button>
                                        </el-dropdown-item>
                                        <el-dropdown-item icon="bi bi-files"><button class="btn btn-sm"
                                                @click="copy(page)">复制</button></el-dropdown-item>
                                        <el-dropdown-item icon="bi bi-folder-minus"><button class="btn btn-sm"
                                                @click="move(page)">移动</button></el-dropdown-item>
                                        <el-dropdown-item icon="bi bi-trash3" divided command="trash(index)"> <button
                                                class="btn btn-sm" @click="trash(index)"> 移到回收站</button></el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div v-else class="p-2">
                                <el-tooltip class="button-item" effect="dark" content="恢复到可编辑状态" placement="top">
                                    <button class="btn btn-sm" @click="unTrash(index)"><i class="bi bi-recycle me-2"></i>
                                        <span class="fs-14">恢复</span>
                                    </button>
                                </el-tooltip>
                                <el-tooltip class="button-item" effect="dark" content="永久删除" placement="top">
                                    <button class="btn btn-sm" @click="remove(index)"><i class="bi bi-trash3 me-2"></i>
                                        <span class="fs-14">删除</span>
                                    </button>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!list">
            <div class="text-muted text-center p-3">
                <div class="spinner-border spinner-border-sm fs-12 text-muted me-2" role="status">
                    <span class="visually-hidden"></span>
                </div>
                <span>加载中...</span>
            </div>
        </div>
        <div v-if="list && list.length < 1" class="text-muted text-center p-3">没有更多数据了</div>
    </div>
</template>


<script>
import { friendlyTime, addImageSuffix } from '../utils'
import api from '../api'

export default {
    props: ['list', 'showAddBtn'],
    methods: {
        friendlyTime,
        addImageSuffix,
        togglePublish(page) {
            page.is_published = page.is_published ? 0 : 1
            api.edit(page.id, { is_published: page.is_published })
        },
        copy() {

        },
        move() {

        },
        async trash(index) {
            const id = this.list[index].id
            const res = await api.trash(id)
            this.list.splice(index, 1)
            this.$emit('handelChange')
        },
        async unTrash(index) {
            const id = this.list[index].id
            const res = await api.untrash(id)
            this.list.splice(index, 1)
            this.$emit('handelChange')
        },
        async remove(index) {
            const id = this.list[index].id
            const res = await api.delete(id)
            this.list.splice(index, 1)
            this.$emit('handelChange')
        }
    }
}
</script>
